import React from "react";
import { Layout } from "antd";

import HeaderMenu from "../../HeaderMenu/HeaderMenu";
import AuditTrailTable from "./AuditTrailTable";
import { PageHeader } from "@ant-design/pro-layout";

const { Content } = Layout;

const AuditTrailTablePage = () => {
  return (
    <>
      <HeaderMenu>
        <PageHeader title={<h1>Audit Trails</h1>} />
      </HeaderMenu>

      <Content
        style={{
          height: "calc(100vh - 64px)",
          overflowY: "hidden",
          position: "relative",
        }}
      >
        <AuditTrailTable />
      </Content>
    </>
  );
};

export default AuditTrailTablePage;
